import React from 'react';
import { Controller } from 'react-hook-form';
import { Input } from '../UIComponents/Form';

export default ({ id, defaultValue = '', ...props }) => (
  <Controller as={<Input id={id} />} defaultValue={defaultValue} {...props} />
);
